import * as tslib_1 from "tslib";
import { PolyUiForm, HtmlForm } from '@swim/ui';
var PieceForm = (function (_super) {
    tslib_1.__extends(PieceForm, _super);
    function PieceForm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PieceForm.addGlobal = function (pieceForm) {
        PieceForm.Global = PieceForm.Global.withUiForm(pieceForm);
    };
    PieceForm.removeGlobal = function (pieceForm) {
        PieceForm.Global = PieceForm.Global.withoutUiForm(pieceForm);
    };
    PieceForm.Global = new PolyUiForm([]);
    return PieceForm;
}(HtmlForm));
export { PieceForm };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGllY2UtZm9ybS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInBpZWNlLWZvcm0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLE9BQU8sRUFBQyxVQUFVLEVBQUUsUUFBUSxFQUFDLE1BQU0sVUFBVSxDQUFDO0FBSTlDO0lBQW1GLHFDQUFjO0lBQWpHOztJQVVBLENBQUM7SUFQUSxtQkFBUyxHQUFoQixVQUFpQixTQUE4QjtRQUM3QyxTQUFTLENBQUMsTUFBTSxHQUFHLFNBQVMsQ0FBQyxNQUFNLENBQUMsVUFBVSxDQUFDLFNBQVMsQ0FBQyxDQUFDO0lBQzVELENBQUM7SUFFTSxzQkFBWSxHQUFuQixVQUFvQixTQUE4QjtRQUNoRCxTQUFTLENBQUMsTUFBTSxHQUFHLFNBQVMsQ0FBQyxNQUFNLENBQUMsYUFBYSxDQUFDLFNBQVMsQ0FBQyxDQUFDO0lBQy9ELENBQUM7SUFSTSxnQkFBTSxHQUFHLElBQUksVUFBVSxDQUF3QixFQUFFLENBQUMsQ0FBQztJQVM1RCxnQkFBQztDQUFBLEFBVkQsQ0FBbUYsUUFBUSxHQVUxRjtTQVZxQixTQUFTIn0=